import { fetcher } from '@commenda/utils';

import {
  TIndirectTaxBulkExportProductsRequest,
  TIndirectTaxBulkExportProductsResponse,
} from './types';

export async function bulkExportIndirectTaxProducts(
  body: TIndirectTaxBulkExportProductsRequest
): Promise<{
  success: boolean;
  error?: string;
  data?: TIndirectTaxBulkExportProductsResponse;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/products/bulk/export',
      { method: 'POST', body },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to export products',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to export products';
    return { success: false, error: errorMessage };
  }
}
